import { render, staticRenderFns } from "./kolhome.vue?vue&type=template&id=f99dde10&"
import script from "./kolhome.vue?vue&type=script&lang=js&"
export * from "./kolhome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports